import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitDavinFoodsQuiz } from "../../redux/actions/index";

const HealthAndSafetyQuiz = ({ appData, submitQuiz }) => {
  const fullName = `${appData.firstName} ${appData.lastName}`;
  const quizName = "healthAndSafetyQuiz";
  const onboarding = appData.davinFoodsOnboarding;

  const initialData = {
    name: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <p className="mb-2 text-center font-weight-bold">
          Please complete the Health & Safety Overview at Davin Foods quiz as
          part of your induction with Reynolds.
        </p>
      ),
    },
    reasons: {
      title:
        "1. What are the 3 main reasons why health and safety are managed?",
      value: getVal("reasons"),
      type: "radio",
      radioOptions: [
        "Cleanliness, safety, and prevention",
        "Ethical, legislative and financial",
        "Managers like rules, punish wrongdoers, and reporting",
        "There is no particular reason",
      ],
      mandatory: true,
    },
    definition: {
      title: "2. What is the definition of an accident?",
      value: getVal("definition"),
      type: "radio",
      radioOptions: [
        "A mistake",
        "An unplanned event which results in some form of loss",
        "Something caused by someone else",
        "Something funny",
      ],
      mandatory: true,
    },
    accidents: {
      title: "3. Why are all accidents investigated?",
      value: getVal("accidents"),
      type: "radio",
      radioOptions: [
        "Because they have to be",
        "So someone can be disciplined",
        "To find out the best one",
        "To identify the root cause and determine corrective actions to prevent a repeat",
      ],
      mandatory: true,
    },
    discover: {
      title:
        "4. What should you do if you discover a significant Health & Safety problem?",
      value: getVal("discover"),
      type: "radio",
      radioOptions: [
        "Get stuck in and fix it yourself",
        "Do a risk assessment",
        "Telephone the Safety Manager",
        "Inform your Line Manager",
      ],
      mandatory: true,
    },
    equipment: {
      title: "5. When you use new equipment for the first time you must:",
      value: getVal("equipment"),
      type: "radio",
      radioOptions: [
        "Be trained in how to use it",
        "Know the hazards associated with the equipment",
        "Ask for help if you are unsure",
        "All of the above",
      ],
      mandatory: true,
    },
    vehicle: {
      title: "6. What should you do if you are near a moving vehicle?",
      value: getVal("vehicle"),
      type: "radio",
      radioOptions: [
        "Get a lift across the yard",
        "Stay a safe distance from it, make sure the driver knows you are there",
        "Ignore it",
        "Chat to the driver while they are driving",
      ],
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);

  const completed =
    onboarding[quizName] &&
    (onboarding[quizName].status === "Pass" ||
      onboarding[quizName].retries === 0);
  const redirectBack = () =>
    history.push("/profile/edit/davin-foods-onboarding");
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuiz(quizName, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };
  return (
    <>
      {completed ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={
            "Health & Safety Overview Induction at Davin Foods Quiz (PR904)"
          }
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"davinFoods"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
HealthAndSafetyQuiz.propTypes = {
  appData: any,
  submitQuiz: func,
};
const mapDispatchToProps = {
  submitQuiz: submitDavinFoodsQuiz,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(HealthAndSafetyQuiz);
